<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="itemCatalogs"
			:loading="loading"
			:height="pageHeight(176)"
			:search="appBarSearch"
			dense
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')">
			<template #item="{ item, index }">
				<tr class="text-left" style="cursor: default" :class="{ 'odd-row': index % 2 }">
					<td>{{ item.name }}</td>
					<td>{{ item.category }}</td>
					<td>{{ item.manufacturer }}</td>
					<td>{{ item.modelNumber }}</td>
					<td class="truncate-text" style="max-width: 30vw">{{ item.notes }}</td>
					<td class="text-right">
						<!-- <v-icon color="primary">mdi-eye</v-icon> -->
						<v-tooltip color="primary" top>
							<template v-slot:activator="{ on }">
								<v-icon v-on="on" color="primary" @click="openAddDrawer(item)">mdi-plus-circle</v-icon>
							</template>
							<span>{{ $t('assign-item') }}</span>
						</v-tooltip>
						<v-icon color="primary" @click="openEditDrawer(item)">mdi-pencil</v-icon>
						<v-icon
							color="primary"
							@click="
								deletingId = item.id;
								showDeleteDialog = true;
							">
							mdi-delete
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
		<DeleteDialog
			:dialog.sync="showDeleteDialog"
			@confirm="
				showDeleteDialog = false;
				deleteItemCatalog(deletingId);
			" />
	</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	name: 'ItemCatalog',
	components: { DeleteDialog },
	data () {
		return {
			loading: true,
			deletingId: -1,
			showDeleteDialog: false,
		};
	},
	computed: {
		...mapState({
			itemCatalogs: (state) => state.inventoryItemCatalogs.itemCatalogs,
		}),
		...mapGetters({
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
		}),
		headers () {
			return [
				{ text: this.$t('name'), value: 'name' },
				{ text: this.$t('category'), value: 'category' },
				{ text: this.$t('manufacturer'), value: 'manufacturer' },
				{ text: this.$t('model-number'), value: 'modelNumber' },
				{ text: this.$t('notes'), value: 'notes' },
				{ text: this.$t('actions'), value: 'actions', align: 'end', sortable: false },
			];
		},
	},
	async mounted () {
		await this.getItemCatalogs();
		this.loading = false;
	},
	methods: {
		...mapActions({
			getItemCatalogs: 'inventoryItemCatalogs/getItemCatalogs',
			deleteItemCatalog: 'inventoryItemCatalogs/deleteItemCatalog',
		}),
		async openAddDrawer (item) {
			await this.$store.commit('inventoryItems/SET_INVENTORY_ITEM_CATALOG', item);
			this.$store.commit('SET_DETAILS_DRAWER', {
				detailsDrawer: true,
				page: 'inventory items',
			});
		},
		async openEditDrawer (item) {
			await this.$store.commit('inventoryItemCatalogs/SET_ITEM_CATALOG', item);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'itemCatalogEdit',
			});
		},
	},
};
</script>
